import { createContext } from 'react';

export const ChartAnimationDisabledContext = createContext(false);
